export function stringToDate(dateString): Date {
  if (!dateString) return new Date();

  const validationRegex = /^\d{8}$/;
  if (!dateString.match(validationRegex)) throw new Error('Date string is not in correct form.');

  const dateRegex = /(\d{4})(\d{2})(\d{2})/;
  const dateMatch = dateString.match(dateRegex);

  const year = dateMatch[1];
  const month = dateMatch[2] - 1;
  const day = dateMatch[3];

  const date = new Date(0);
  date.setFullYear(year, month, day);
  // date.setHours(0);
  // date.setMinutes(0);
  // date.setSeconds(0);
  // date.setMilliseconds(0);

  return date;
}

export function mapFilter(filter): any {
  if (!filter) return {};

  return Object.values(filter).reduce((agg: any, condition: any) => {
    const { field, operator, value } = condition;

    // TODO: verify value exists, can be 0 or false but not null, undefined or empty string
    if (!(field && operator && value)) return agg;

    // should be snake case or column name from config
    const key = condition.field;

    agg[key] = {
      [condition.operator]: condition.value,
      operator: condition.operator,
      value: condition.value
    };
    return agg;
  }, {});
}

export const formatPercent = (value, precision = 2): string => {
  const percentage = (value * 100).toFixed(precision);
  return `${percentage}%`;
};

export const formatCurrency = (value, currencySymbol = '$'): string => {
  if (value !== 0 && !value) return '';

  const formattedValue = Number(value)
    .toFixed(2)
    .replace(/\d(?=(\d{3})+\.)/g, '$&,');
  return `${currencySymbol}${formattedValue}`;
};

export const formatInteger = (value): string => Number(value).toLocaleString();

export const formatNumber = (value, precision = 2): string => {
  if (!Number(value)) return value;

  const num = Number(value).toFixed(precision);
  return `${num}`;
};

export const truncateString = (value, length = 30): string => {
  return value.length < length ? value : value.substr(0, length) + '...';
};

export const formatDateString = (isoDateString): string => {
  return new Date(isoDateString).toString();
};

export const formatDate = (date): string => {
  return stringToDate(String(date)).toDateString();
};
